import { UserState } from '../types';

const state: UserState = {
  profile: {},
  loggedIn: false,
};

export default state;
